module.exports = __webpack_public_path__ + "img/swipe (2).bdcb8e79.jpg";